var basex = require('base-x')
var ALPHABET = 'rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz'

module.exports = basex(ALPHABET)
